import AppConstants from "constants/AppConstants";

export const createNotificationPayload = (payload: {pageNumber: number ; pageSize: number}, countryCode: string, activeTab: number) => {
  const country = sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode;

  return {
    ...payload,
    countryCode: country,
    attributes: [
      {
        key: "ack",
        value: activeTab === 0 ? [false] : [true], // Unread: false, Read: true
      },
    ],
  };
};